// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".i-link {\n  cursor: pointer;\n}\n.i-link-color,\n.i-link-color:hover,\n.i-link-color:active {\n  color: inherit;\n}\n", ""]);
// Exports
module.exports = exports;
